import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import {registerLicense} from '@syncfusion/ej2-base';

if (environment.production) {
  enableProdMode();
}

registerLicense('NDMwNTE2N0AzMjMxMmUzMTJlMzMzNUgrRmNZSDlsU1hhSTdha0xYaThBd25qUmd6UVlzV1RaQm14emJlUTE0TWc9;NDMwNTE2OEAzMjMxMmUzMTJlMzMzNWpWVTlnSlltUkk4TEdHVW1wUFVZWU5MS042L3luNlRVdThReFN3RGN3RHM9;Mgo+DSMBPh8sVXJ1S0d+X1RPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9lSXpTfkRjXX5acnJQTmlXU0U=;ORg4AjUWIQA/Gnt2VFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hT35Xdk1iWXtfdHZTQWJUWkZ3;NRAiBiAaIQQuGjN/V0d+XU9Hc1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTckVrWH9acXBXQGhUUk90Xg==;NDMwNTE3MkAzMjMxMmUzMTJlMzMzNVg4b0pCa0Q3MzM0ZGltblpzNTc1R0J2WlBMU2JlZFN1ak5lN1Nvdk45TVU9;NDMwNTE3M0AzMjMxMmUzMTJlMzMzNWE3eng4RXZXRW9Pak9Yei9pcEVmSlJ6SE9FUlpHeXFDbE5vck9IV3VwQ2c9;Mgo+DSMBMAY9C3t2VFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hT35Xdk1iWXtfdHZSTmNdWkZ3;NDMwNTE3NUAzMjMxMmUzMTJlMzMzNVZ3dVFYdDZiRUdQaU10WVRQak5KNG40V2NRV05DK3NzVW9rZVBweENMOVk9;NDMwNTE3NkAzMjMxMmUzMTJlMzMzNVNjTFAyRFErdFV6b0Fjc3daMEwxTVRqYURicXkwN2pkZGhBL3hEVmMrWkE9;NDMwNTE3N0AzMjMxMmUzMTJlMzMzNVg4b0pCa0Q3MzM0ZGltblpzNTc1R0J2WlBMU2JlZFN1ak5lN1Nvdk45TVU9;NDMwNTE3OEAzMjMxMmUzMTJlMzMzNW5aZ0Zsc2NaQ1g1UGdXQUptUk1jSU11SERiNEN0eFptU2JyRWFaL1d3aVk9');

platformBrowserDynamic().bootstrapModule(AppModule).catch((err) => {
  console.error(err);
  return onInitError();
});


function onInitError() {
  const body = document.getElementsByTagName('body')[0];
  body.innerHTML = getErrorPage();
}

function getErrorPage() {
  return `<div id="errorpage" style="max-width: 450px; text-align: center;" class="m-x-auto w-auto-xs p-y-md">
  <div class="p-a-md box-color r box-shadow-z1 text-color m-a">
    <div class="login-logo"></div>
      <div class="alert alert-danger m-t-sm" role="alert">
        Server unavailable.
        <a onclick="window.location.reload()" class="text-primary _600">Try again</a>
      </div>
  </div>
</div>`;
}
